import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CIRCUIT_PATH } from '../../../../config/paths';

const CloneCircuitButton = ({ circuitId }) => (
  <Link className="btn btn-info" to={`${CIRCUIT_PATH}/${circuitId}/clone`}>
    <i className="fa fa-clone" /> Clonar
  </Link>
);

CloneCircuitButton.propTypes = {
  circuitId: PropTypes.number.isRequired,
};

export default CloneCircuitButton;
